import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';

import { AuthFacade, ResourcesService } from '@mitsubishi/core';
import { ConfigurationAlertsDialogComponent } from '@mitsubishi/project/shared';
import { PerformanceMessage } from '@mitsubishi/shared/data-access';
import { DialogService } from '@mitsubishi/ui/dialog';

import { FieldWrapper } from '@ngx-formly/core';

import { FormlyTableWrapperColumn } from '../../models/table-wrapper-column';
import { ApmFormlyService } from '../../services/formly.service';

@Component({
  selector: 'apm-table-wrapper',
  templateUrl: './table-wrapper.component.html',
  styleUrls: ['./table-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TableWrapperComponent extends FieldWrapper implements OnInit {
  canDebug = inject(AuthFacade).canDebug;

  tableColumns: FormlyTableWrapperColumn[] = [];

  isFirst = false;

  constructor(
    private serverResourceService: ResourcesService,
    private dialogService: DialogService,
    private formlyService: ApmFormlyService
  ) {
    super();
  }

  ngOnInit() {
    if (this.field.props && this.field.props['tableColumns']) {
      this.tableColumns = this.field.props['tableColumns'];
    }
    this.isFirst = this.field?.parent?.fieldGroup?.findIndex(f => f.key === this.field.key) === 0;
  }

  showErrorMessages(errorsResource: number[]) {
    const errorMessages: PerformanceMessage[] = errorsResource.map((error: any) => {
      return {
        code: '',
        description: '',
        descriptionId: error.id,
        messageType: 2,
        parameters: [error.performanceValue, error.performanceUserValue],
      };
    });

    const data = {
      messages: errorMessages,
      title: this.serverResourceService.getTextResource('445235'),
    };
    this.dialogService.openDialog(ConfigurationAlertsDialogComponent, 'md', data);
  }

  onColumnClick(column: FormlyTableWrapperColumn) {
    this.formlyService.dispatchEvent({
      event: 'TABLE_HEADER_COLUMN_CLICK',
      data: column,
    });
  }
}
